module.exports = __webpack_public_path__ + "img/4.a81c8238.png";